// extracted by mini-css-extract-plugin
module.exports = {"label":"SelectModal_label__1jAic","description":"SelectModal_description__1dhzh","buttons":"SelectModal_buttons__3Oig-"};